import { UserRole } from '@libs/schemas';
import { User, getAuth } from 'firebase/auth';
import { FC, PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';

export interface UserContextT {
  user: User | null;
  userRoles: UserRole[];
}

export const UserContext = createContext({} as UserContextT);

export const UserContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [user, setUser] = useState<User | null>(getAuth().currentUser);
  const [loaded, setLoaded] = useState(false);
  const [userRoles, setUserRoles] = useState<UserRole[]>([]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged(async (u) => {
      setUser(u);
      const results = await u?.getIdTokenResult();
      setUserRoles(results?.claims.roles as UserRole[]);
      setLoaded(true);
    });
    return () => unsubscribe();
  }, []);

  if (!loaded) return <></>;

  return <UserContext.Provider value={{ user, userRoles }}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  return useContext(UserContext);
};
